import { AlphaVBoxIcon } from './AlphaVBoxIcon';

/**
 * author: GreenTurtwig
 * id C3B68231-EFA7-4988-BED2-9C158A812AC4
 * name alpha-v-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterVBoxIcon = AlphaVBoxIcon;
export default LetterVBoxIcon